import React from "react";

const DataGridRowContext = React.createContext<unknown | undefined>(undefined);

export default DataGridRowContext;
